import CustomRow from './custom-row.gts';
import CustomRowReview from './custom-row-review.gts';
import LoadingRow from './loading-row.gts';
import { t } from 'ember-intl';
import Button from 'tio-ui/components/button';
import type { ComponentLike } from '@glint/template';
import type { TOC } from '@ember/component/template-only';
import type { TasProgramTemplateReviewCustomRowSig } from './custom-row.ts';
import type { TuitionAssistanceProgramTemplateReviewCustomRowReviewSignature } from './custom-row-review.ts';
import { PhPlus } from 'ember-phosphor-icons';
import { Section } from 'tio-ui/components/layout';

interface TasPrgmTmplReviewAddCustomFieldSig {
  Args: {
    addCustomRow?: () => void;
    showCustomField: boolean;
    isLoadingNewRow?: boolean;
  };
  Blocks: {
    default: [
      {
        row: ComponentLike<TasProgramTemplateReviewCustomRowSig>;
        customRowReview: ComponentLike<TuitionAssistanceProgramTemplateReviewCustomRowReviewSignature>;
        loadingRow: ComponentLike<unknown>;
      },
    ];
  };
}

const TasProgramTemplateReviewAddCustomField: TOC<TasPrgmTmplReviewAddCustomFieldSig> = <template>
  <Section>
    {{#if @showCustomField}}
      <h2 class="col-span-3 tio-text-sm-semibold mt-6 mb-4 uppercase">
        {{t "common.tuition_assistance.program_template_review.custom_field.custom_fields_added"}}
      </h2>
      <div
        class="grid grid-cols-10 gap-8 font-semibold tio-bg-info-soft p-4 justify-center items-center"
      >
        <span class="col-span-1">
          {{t "common.tuition_assistance.program_template_review.custom_field.order_number"}}
        </span>
        <span class="col-span-3">{{t
            "common.tuition_assistance.program_template_review.field"
          }}</span>
        <span class="col-span-2 pl-4">
          {{t "common.tuition_assistance.program_template_review.type"}}
        </span>
        <span class="col-span-2 justify-self-center">
          {{t "common.tuition_assistance.program_template_review.visible_to_employees"}}
          /{{t "common.required"}}
        </span>
      </div>
      {{yield
        (hash
          row=(component CustomRow)
          customRowReview=(component CustomRowReview)
          loadingRow=(component LoadingRow)
        )
      }}
    {{/if}}

    {{#if @addCustomRow}}
      <Button
        @appearance="outlined"
        @intent="primary"
        @icon={{PhPlus}}
        @iconPlacement="start"
        {{on "click" @addCustomRow}}
        class="m-2 tio-text-sm-semibold uppercase"
      >
        {{t "common.tuition_assistance.program_template_review.add_custom_field"}}
      </Button>
    {{/if}}
  </Section>
</template>;

export default TasProgramTemplateReviewAddCustomField;
